import { getCookieConsent, getAmplitudeApiKey, shouldSendToAmplitude } from '../helpers';

// Disable force touch
document.addEventListener('webkitmouseforcewillbegin', function(event){
    event.preventDefault();
});

// Setup AJAX
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function() { 
    // Currency
    $(document).on('keyup', '.currency', function(event){
        var value = $(event.currentTarget).val();
        $(event.currentTarget).closest('.form-field').toggleClass('currency-symbol', value != '');
    });

    // Menu smooth scrolling
    $(document).on('click', '.home #main_nav li a[href^="/#"]', function(event){
        event.preventDefault();
        var target = $(event.currentTarget);
        var id = target.attr('href').split('#')[1];
        var section = $('#' + id);
        if(section.length === 1){
            $('html, body').animate({
                scrollTop: section.offset().top
            }, 500);
        }
    });

    // Fix select boxes on iOS
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
        $('select').addClass('ios-select'); // provide a class for iOS select box
        $('select[size]').removeAttr('size');
    }
});

export function setCookie(cname, cvalue, exseconds) {var d = new Date();d.setTime(d.getTime() + (exseconds*1000));var expires = "expires="+d.toUTCString();document.cookie = cname + "=" + escape(cvalue) + "; " + expires +"; path=/";}
export function getCookie(c_name){var c_value = document.cookie;var c_start = c_value.indexOf(" " + c_name + "=");if (c_start == -1){c_start = c_value.indexOf(c_name + "=");}if (c_start == -1){c_value = null;}else{c_start = c_value.indexOf("=", c_start) + 1;var c_end = c_value.indexOf(";", c_start);if (c_end == -1){c_end = c_value.length;}c_value = unicodeToChar(unescape(c_value.substring(c_start,c_end)));}return c_value;}
window.delCookie = function(name){document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';}
function unicodeToChar(text) {return text.replace(/\\u[\dA-F]{4}/gi, function (match) { return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16)); });}
function updateCookie($cookieName, $varName, $varValue, $expirySeconds) {var cookieData = JSON.parse(getCookie($cookieName)); if (cookieData > '' && $varValue > '') { cookieData[$varName] = $varValue.toString(); } var $cookieString = JSON.stringify(cookieData); setCookie($cookieName, $cookieString, $expirySeconds);}

let amplitudeApiKey = getAmplitudeApiKey() || [];
let loopCount = 1;
let cookieLoop = setInterval(function() {
    if (loopCount >= 15) {
        clearInterval(cookieLoop);
    }
    loopCount++;
    let cookieConsent = getCookieConsent();
    if (cookieConsent === 'true' || cookieConsent === 'false') {
        clearInterval(cookieLoop);
        processAmplitudeInit(cookieConsent);
    }
}, 1000);

function processAmplitudeInit(cookieConsent) {
    let optOut;
    let disableCookies;

    switch(shouldSendToAmplitude(cookieConsent)) {
        case true:
            disableCookies = false;
            optOut = false;
            window.amplitude.initialiseAmplitude(amplitudeApiKey, disableCookies, optOut);
            break;
        case false:
            disableCookies = true;
            optOut = true;
            window.amplitude.initialiseAmplitude(amplitudeApiKey, disableCookies, optOut);
            break;
    }
}

//toggle form FAQs
$(function() {
    $('.accordion-header').on('click', function(event) {
        $('.faq-accordion').slideToggle(250);
        var faqArrow = $('.accordion-header').find('.accordion-status');
        faqArrow.toggleClass('closed');
    });
});

//faq dropdown functionality
$(function() {
    $('.faq-question-text').on('click', function(event) {
        $('.faq-accordion').show();
        var faqWrapper = $(event.target).closest('.faq-wrapper');
        var faqAnswer = faqWrapper.find('.faq-answer-text');

        //toggle the open close of the plus symbol
        $(this).toggleClass('rotate');

        // Close all other open FAQ sections and rotate the plus symbol
        $('.faq-answer-text.open').not(faqAnswer).slideUp(250).removeClass('open');
        $('.faq-question-text.rotate').not($(this)).removeClass('rotate');

        // Open/close the clicked FAQ section
        faqAnswer.slideToggle(250).toggleClass('open');
    });
});

$(function() {
    $('.faq-link').on('click', function(event) {
        var questionId = '#faq-' + $(this).attr('faq-question');
        var signpostText= $(this).closest('.help-text').text().trim();
        var targetQuestionText = $(questionId).find('.question').text();
        $(questionId).trigger('click');
        // Smooth scroll to the element
        $('html, body').animate({
            scrollTop: $(questionId).offset().top -350
        }, 'slow');
        //fire amplitude event to track the faq link click
        window.amplitude.faqLinkClick(signpostText, targetQuestionText);
    });
});

//keep the first FAQ element open by default on all faq pages for SEO.
$(function() {
    // Open the first FAQ
    $('.faq-question-text').first().addClass('rotate');
    $('.faq-answer-text').first().addClass('open').show();
});

//sends event to amplitude
$('.landing-cta').on('click', function(event) {
    const link = $(this); // Get a reference to the clicked link element

    // Retrieve the desired properties from the link's attributes or text content
    const section = link.closest("section").attr("class");
    const buttonText = link.text().trim();
    const buttonUrl = window.location.href;
    const targetUrl = link.attr('href');
    const buttonColor = link.css('background-color');

    const eventProperties = {
        section: section,
        button_text: buttonText,
        button_url: buttonUrl,
        target_url: targetUrl,
        button_color: buttonColor,
    };

    window.amplitude.buttonClickEvent(eventProperties);
});

//show factchecked tooltip on click for mobile devices.
$('.factchecked').on('click', function(event) {
    var $popup = $(this).siblings('.popup');
    if($popup.css('opacity') == '0') {
        $popup.css({
            'display': 'inline',
            'opacity': '1'
        });
    } else {
        $popup.css({
            'display': 'none',
            'opacity': '0'
        });
    }
});

$(document).ready(function() {
    // Dropdown menu toggle
    $('#dropdownDefaultButton').on('click', function(event) {
        $('#dropdown').toggleClass('hidden');
        event.stopPropagation();
    });
    // Dropdown closes when clicked outside of dropdown menu
    $(document).on('click', function(event) {
        var $target = $(event.target);
        if (!$target.closest('#dropdown').length && !$target.closest('#dropdownDefaultButton').length) {
            $('#dropdown').addClass('hidden');
        }
    });
    // Prevent clicks within the dropdown from closing it
    $('#dropdown').on('click', function(event) {
        event.stopPropagation();
    });
    $('.dropdown-link').on('click', function(event) {
        $('#dropdown').addClass('hidden');
    });
});

$('.faq-title').on('click', function(event) {
    var faqText = $(this).find('.question').text();
    var action = 'open';
    if (!$(this).find('.faq-question-text').hasClass('rotate')) {
        action = 'close';
    }
    window.amplitude.faqInteraction(faqText, action);
});
